import React from "react"
import {
    Button,
    FormControl,
    FormControlLabel,
    Grid,
    Radio,
    RadioGroup,
    TextField,
    Typography,
    Dialog,
    Modal
} from "@mui/material";
import { Box, display } from "@mui/system";

const NotificationComponent = (props) => {
    const { array } = props

    const routeToAllNoti = () => {
        window.location.href = "/AllNotification"
    }
    return (
        <>
         {array && array.length > 0 ? 
            <Box sx={{ borderRadius: "0.5rem" }}>
                <Typography style={{padding:"10px" ,justifyContent: "flex-start", fontSize: "25px", color: "white", paddingLeft: "10px", marginTop: "10px" }}>Notification</Typography>

                <Box sx={{ alignSelf: "stretch", border: "1px solid grey", marginTop: "10px" }}></Box>

                {array.slice(0,5).map((ele, index) => {
                    return (
                        <>
                            <Box sx={{ marginTop: "20px", display: "flex", padding:"5px" , gap: "10px"}}>
                                <img
                                    style={{ height: "40px", width: "40px", backgroundColor: "#69B0F1", borderRadius: "0.5rem" }} src="/Frame.png"
                                />
                                 <Box> 
                                   <Typography sx={{ color: "white", fontSize:"20px" }}>{ele?.title}</Typography>
                                   <Typography sx={{color: "white", paddingTop:"10px" }}>{ele?.message}</Typography>
                                 </Box>
                            </Box>

                            <Box sx={{ alignSelf: "stretch", border: "1px solid grey", marginTop: "10px" }}></Box>
                        </>
                    )
                })}

                <Box sx={{paddingTop:"10px"}}>
                    <Button onClick={routeToAllNoti} sx={{color:"white", fontSize:"16px", fontWeight:"500"}}>See All Notification</Button>
                </Box>

            </Box>
         : 
          <Box sx={{marginTop:"50px", marginBottom:"50px", justifyContent:"center", display:"flex"}}>
           <Typography sx={{color:"white"}}>No Notifications</Typography>
           </Box>
         }
        </>
    )
}

export default NotificationComponent;